module.exports = __webpack_public_path__ + "img/banner3-En1.bc116274.jpg";